/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Duration_PlaceholderInputs */

const en_job_form_duration_placeholder = /** @type {(inputs: Job_Form_Duration_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. 6 months`)
};

const de_job_form_duration_placeholder = /** @type {(inputs: Job_Form_Duration_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. 6 Monate`)
};

/**
* | output |
* | --- |
* | "e.g. 6 months" |
*
* @param {Job_Form_Duration_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const job_form_duration_placeholder = /** @type {((inputs?: Job_Form_Duration_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Duration_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_duration_placeholder(inputs)
	return en_job_form_duration_placeholder(inputs)
});